import { render, staticRenderFns } from "./ModalDelete.vue?vue&type=template&id=64e0ba2a&"
import script from "./ModalDelete.vue?vue&type=script&lang=js&"
export * from "./ModalDelete.vue?vue&type=script&lang=js&"
import style0 from "./ModalDelete.vue?vue&type=style&index=0&id=64e0ba2a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports